import { useEffect, useMemo } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import MonthlyPrime from '../organisms/MonthlyPrime';
import { getDefaultPrimeReferenceDate, isValidMonthYear, parseMonthYearToDate } from '../../utils/monthlyPrime.utils';

export type PrimesOutletContext =
  | {
      tamEmail: string;
      tamDisplayName: string;
      referenceDate: Date;
    }
  | undefined;

const PrimesMonthlyPage = () => {
  const { mmYyyy } = useParams<{ mmYyyy?: string }>();
  const navigate = useNavigate();
  const outletContext = useOutletContext<PrimesOutletContext>();

  const referenceDateFromUrl = useMemo(() => {
    if (mmYyyy === undefined) {
      return undefined;
    }
    if (!isValidMonthYear(mmYyyy)) {
      return null;
    }
    return parseMonthYearToDate(mmYyyy);
  }, [mmYyyy]);

  useEffect(() => {
    if (referenceDateFromUrl === null) {
      navigate('/primes/mois', { replace: true });
    }
  }, [navigate, referenceDateFromUrl]);

  if (referenceDateFromUrl === null) {
    return null;
  }

  const referenceDate = referenceDateFromUrl ?? outletContext?.referenceDate ?? getDefaultPrimeReferenceDate();

  return (
    <MonthlyPrime
      key={`${outletContext?.tamEmail ?? 'admin'}-${referenceDate.toISOString()}`}
      tamEmail={outletContext?.tamEmail}
      tamDisplayName={outletContext?.tamDisplayName}
      referenceDate={referenceDate}
    />
  );
};

export default PrimesMonthlyPage;
